<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input clearable v-model="page.bankNumber" size="small" placeholder="银行流水号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-input clearable v-model="page.payer" size="small" placeholder="付款方" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6" class="input-group">
        <el-input clearable v-model="page.MinMoney" size="small" placeholder="最小回款金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <span>~</span>
        <el-input clearable v-model="page.MaxMoney" size="small" placeholder="最大回款金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
      </el-col>
      <el-col :span="4" class="input-group">
        <el-select clearable v-model="page.returnStatus" size="small" placeholder="未选择认领状态" class="w-100">
          <el-option v-for="(item, index) in rlList" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="银行流水号" prop="bankSerialNumber" align="center">
        </el-table-column>
        <el-table-column label="付款方" prop="payer" align="center">
        </el-table-column>
        <el-table-column label="回款金额" prop="returnMoney" align="center"></el-table-column>
        <el-table-column label="回款日期" prop="returnTime" align="center">
			<template slot-scope="scope">
				<span>{{(scope.row.returnTime||'').split(' ')[0]}}</span>
			</template>
		</el-table-column>
        <el-table-column label="已认领金额" prop="claimMoney" align="center"></el-table-column>
		<el-table-column label="待认领金额" prop="waitClaimMoney" align="center"></el-table-column>
        <el-table-column label="回款凭证" prop="fileList" align="center">
		  <template slot-scope="scope">
        <filePreview :fileList="scope.row.fileList"></filePreview>
			<!-- <a style="display: block;" v-for="(item,index) in scope.row.fileList" :key='index' class="link" href="javascript:void(0);" @click="downloadFile(item.path,item.name)" :download="item.path">{{item.name}}</a> -->
			<span v-if="scope.row.fileList == null||scope.row.fileList == []">--</span>
		  </template>
        </el-table-column>
        <el-table-column label="认领状态" prop="status" align="center">
          <template slot-scope="scope">
			  <span v-if="scope.row.status==1">未认领</span>
			  <span v-else-if="scope.row.status==2">部分认领</span>
			  <span v-else-if="scope.row.status==3">完全认领</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="lookInfo(scope.row.id)">详情</el-button>
			<el-button v-if="scope.row.status==1||scope.row.status==2" type="text" size="small" @click='goel(scope.row.id)'>认领</el-button>
			<el-button v-if="scope.row.status==3||scope.row.status==2" type="text" size="small" @click='openrlList(scope.row.id)'>认领记录</el-button>
			<!-- <el-button  type="text" size="small" @click='openrlList(scope.row.id)'>认领记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <!-- 回款详情 -->
    <el-dialog title="回款详情" :visible.sync="Invoicedialog" width="80%">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules" label-width="130px">
        <el-form-item label="银行流水号:" prop="bankSerialNumber" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.bankSerialNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="回款金额:" prop="returnMoney" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.returnMoney" disabled></el-input>
        </el-form-item>
        <el-form-item label="回款日期:" prop="returnTime" class="block-form-item w-32">
          <el-input v-model="(InvoiceForm.returnTime||'').split(' ')[0]" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款类型:" prop="returnType" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.returnType" class="w-100" disabled>
              <el-option v-for="(item,index) in hkType" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款账户:" prop="account" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.account" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款账户开户行:" prop="bankDeposit" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.bankDeposit" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款账户:" prop="payeeName" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.payeeName" disabled></el-input>
        </el-form-item>
        <el-form-item label="认领状态:" prop="status" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.status" class="w-100" disabled>
               <el-option v-for="(item,index) in rlList" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="待认领金额:" prop="waitClaimMoney" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.waitClaimMoney" disabled></el-input>
		</el-form-item>
		<el-form-item label="录入人:" prop="createUserName" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.createUserName" disabled></el-input>
		</el-form-item>
		<el-form-item label="录入时间:" prop="createTime" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.createTime" disabled></el-input>
		</el-form-item>
		<el-form-item label="收款凭证:" prop="fileList" class="block-form-item">
			<template slot-scope="scope">
        <filePreview :fileList="InvoiceForm.fileList" :modalShow="false"></filePreview>
				<!-- <a style="display: block;" v-for="(item,index) in InvoiceForm.fileList" :key='index' class="link" href="javascript:void(0);" @click="downloadFile(item.path,item.name)" :download="item.path">{{item.name}}</a> -->
				<span v-if="InvoiceForm.fileList.length == 0">--</span>
			</template>
		</el-form-item>
        <el-form-item label="备注:" prop="remark" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="InvoiceForm.remark" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 作废详情 -->
    <el-dialog title="作废详情" :visible.sync="invoiceVisible" width="50%">
	  <el-form :model="zfData" ref="zfData" :rules="rules" label-width="110px">
		  <div style="display: flex;justify-content: space-between;">
			  <el-form-item label="作废人:" prop="reasonUserName" class="" style="width: 45%;">
			      <el-input v-model="zfData.reasonUserName" disabled></el-input>
			    </el-form-item>
			    <el-form-item label="作废时间:" prop="reasonTime" class="block-form-item " style="width: 45%;">
			      <el-input v-model="zfData.reasonTime" disabled></el-input>
			    </el-form-item>
		  </div>
		  <el-form-item label="作废原因:" prop="companyAddress" class="block-form-item w-16">
		     <el-input type="textarea" maxlength="300" show-word-limit v-model="zfData.reason" disabled=""></el-input>
		  </el-form-item>
<!-- 		  <div class="mar-c">
		    <el-button type="primary" size="small" @click="invoiceVisible=false" :disabled="submitLoading">确定</el-button>
		  </div> -->
	  </el-form>
    </el-dialog>
    <!-- 认领记录 -->
    <el-dialog title="认领记录" :visible.sync="approveVisible" width="80%" v-loading="approveLoading">
		  <template>
		    <el-table
		      :data="rlData"
		      style="width: 100%">
		      <el-table-column prop="contractName" label="认领商务合同名称"  width="180"></el-table-column>
			  <el-table-column prop="claimMoney" label="认领回款金额"  width="180"></el-table-column>
			  <el-table-column prop="createUserName" label="认领操作人"  width="180"></el-table-column>
			  <el-table-column prop="createTime" label="认领操作时间"  width="180"></el-table-column>
			  <el-table-column prop="claimStatus" label="状态"  width="180">
				  <template slot-scope="scope">
						<span v-if="scope.row.claimStatus==0">已认领</span>
						<span v-else-if="scope.row.claimStatus==1">已作废</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center">
			    <template slot-scope="scope">
						<el-button v-if="scope.row.claimStatus==0" type="text" size="small" @click="zfClick(scope.row)">作废</el-button>
					    <el-button v-if="scope.row.claimStatus==1" type="text" size="small" @click='zfInfo(scope.row.id)'>作废详情</el-button>
			    </template>
			  </el-table-column>
		    </el-table>
		  </template>
		  <!-- 分页 -->
		  <div class="pagination-wrap">
		    <el-pagination background @size-change="rlSizeChange" @current-change="rlCurrentChange" :current-page.sync="rlpage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="rlpage.pageSize"
		      layout="sizes, prev, pager, next, jumper" :total="rlpage.total">
		    </el-pagination>
		  </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import InvoiceFormFields from "@/const/form/InvoiceForm";
import { billingConfig } from "@/const/config/billing";
import {
	hkList,hkInfo,rlList,zfInfoApi,
} from "@/api/business/back";
import { processList } from "@/api/approve/contract";
import approveList from "@/components/common/approveMember";
export default {
  components: {

  },
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
	  hkid:'',//单个回款id
	  hkType:[
		  {label:'商务合同回款',value:1},
		  // {label:'品牌合同回款',value:2},
	  ],//回款类型
	  rlList:[
		  {label:'未认领',value:1},
		  {label:'部分认领',value:2},
		  {label:'完全认领',value:3},
	  ],//认领状态1未认领 2部分认领 3完全认领
	  rlData:[],//认领记录
	  zfData:{},//作废信息
	  fileList: [],//凭证
      billingConfig,
      approveVisible: false,
      approveLoading: false,
	  Invoicedialog: false, //回款详情
	  approveTitle:false,
	  invoiceVisible: false,//作废详情
	  zftxVisible:false,//作废提醒
      /**
       * 开票提醒模块
       */
      isUploadFile: false, //是否上传
      hasCorrectIncome: false, //KOL收入+有花果收入=净收入
      hasRemainingMoney: false, //剩余金额大于可开票金额


      contractConfig: contractConfig,
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
      },
      InvoiceForm: {
			account: "",
			bankAccount: null,
			bankDeposit: "",
			bankSerialNumber: "",
			claimMoney: null,
			createTime: "",
			createUserId: "",
			createUserName: "test",
			deleteFlag: null,
			payeeName: "",
			payer: "",
			remark: "",
			returnMoney: 0,
			returnTime: "",
			returnType: 1,
			status: 1,
			voucher: "",
			waitClaimMoney: 0,
      },
      rules: {
        invoiceMoney: [
        ],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
		MaxMoney:null,//最大值
		MinMoney:null,//最小值
		bankNumber:'',//银行流水号
		payer:'',//付款方
		returnStatus:null,//认领状态
		returnType:null,//回款类型
      },
	  rlpage:{
		  pageNum: 1,
		  pageSize: 10,
		  total: 0,
	  },//认领列表分页
      submitLoading: false,
      tableData: [],
      tableLoading: false,
      /**
       * 业务负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,
      pid: null,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
	  //获取文件后缀名
	  getWordname(str){
	  	var index = str.lastIndexOf("\/");  
	  	str  = str.substring(index + 1, str .length);
	  	return str
	  },
	  //跳转认领
	  goel(id){
		  let router = this.$router.resolve({
		    path: "/business/backMoney/edit",
		    query: {
		      id: id,
		    },
		  });
		  window.open(router.href, "_blank");
	  },
	// 查看详情
	lookInfo(id){
	  this.Invoicedialog = true
	  hkInfo(id)
	    .then((res) => {
	  			this.InvoiceForm  = res.data
	    })
	    .catch((err) => {
	  			
	    });
	},
	//打开认领记录
	openrlList(id){
			this.approveVisible = true
			this.hkid = id
			this.getRl();
	},
	// 获取认领记录
	getRl(){
		let obj = {
			id:this.hkid,
			pageNum:this.rlpage.pageNum,
			pageSize:this.rlpage.pageSize,
		}
		rlList(obj)
		  .then((res) => {
				console.log('我是认领记录',res)
				this.rlData = res.data
				this.rlpage.total = res.total;
				console.log('我是认领记录总数',this.rlpage.total)
		  })
		  .catch((err) => {
					
		  });
	},
	//点击作废
	zfClick(){
		        this.$alert('请联系财务操作作废', '作废提醒', {
		          confirmButtonText: '确定',
		          callback: action => {
					
		          }
		        });
	},
	//作废信息
	zfInfo(id){
		this.invoiceVisible = true
		zfInfoApi(id)
		  .then((res) => {
				console.log('我是作废信息',res)
				this.zfData = res.data
		  })
		  .catch((err) => {
					
		  });
	},
	// 上传凭证
	  handleRemove(file, fileList) {
		console.log(file, fileList);
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
	  beforeRemove(file, fileList) {
		return this.$confirm(`确定移除 ${ file.name }？`);
	  },
    /**重新提交 */
    reSubmit(contractId) {
      this.$confirm("确认重新提交启动审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reapply({ contractId }).then((res) => {
            this.$message.success("重新提交成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal(username, id, pid) {
      if (username) {
        this.selectAdmin = {
          username,
          id,
        };
      } else {
        this.selectAdmin = null;
      }
      this.pid = pid;
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminForm.queryString = "";
      this.selectAdminId = null;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        let obj = {
          businessPrincipalId: this.selectAdmin.id,
          contractId: this.pid,
        };
        editAdmin(obj)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("分配成功！");
              this.getList();
            }
          })
          .catch((err) => {});
        this.adminListModal = false;
      } else {
        this.$message.error("不能删除业务负责人！");
      }
    },
    /**认领列表
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    rlSizeChange(val) {
      this.rlpage.pageNum = 1;
      this.rlpage.pageSize = val;
      this.getRl();
    },
    /**认领列表
     * 监听页数变化
     * @param val 当前页数
     */
    rlCurrentChange(val) {
      this.rlpage.pageNum = val;
      this.getRl();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log(this.selectAdminId);
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

    //提交
    onSubmit() {
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          let f = util.deepClone(this.InvoiceForm);
          InvoiceAdd(f).then((res) => {
            if (res.code == 1) {
              this.$message.success("申请成功！");
              this.Invoicedialog = false;
              this.getList();
            }
          });
        } else {
          let a = Object.keys(obj).map((v) => {
            let text = "";
            if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
              let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
              text = InvoiceFormFields.list[fieldInArray];
            } else {
              text = InvoiceFormFields.list[v];
            }
            return text;
          });
          this.$message.error(
            "表单不完整！请检查" + a.join("、") + "是否按要求填写"
          );
        }
      });
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },

    // 搜索
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      this.tableLoading = true;
      hkList(this.page)
        .then((res) => {
			console.log(res)
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
			
        });
    },

    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.resolve({
        path: "/business/contract/edit",
        query: {
          id: id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    Invoicedialog(val) {
      if (!val) {
        this.InvoiceForm = {
          contractId: null, //合同ID
          customerName: "", //名称
          companyPhone: "", //电话
          companyAddress: "", //公司地址
          taxpayerId: "", //纳税人识别号
          customerBank: "", //客户开户行
          customerBankAccount: "", //客户银行账户
          invoiceMoney: "", //开票金额
          invoiceType: "", //发票类型
          invoiceDetail: "", //开票明细
          remark: "", //合同备注
        };
        this.$refs.InvoiceForm.clearValidate("invoiceMoney");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrap{
	margin-top: 20px;
}
.mar-c {
  display: flex;
  justify-content: center;
}
.table-count {
  margin: 15px 0 10px;
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
</style>